<template>
  <div class="verification-message">
    <app-layout class="home-page-template">
      <div style="padding: 15px">
        <h1 align="center">Confirm your Email</h1>
        <br/>
        <p align="center">A confirmation email has been sent to <b>{{myEmail}}</b>.</p>
        <p align="center">Click the link on the email to confirm your email address.</p>
        <br/>
        <p align="center">
          <i-button long @click="resendVerification()">
            Resend Confirmation
          </i-button>
          <i-button long @click="$router.replace('/home')" type="text">
            <a>continue as guest</a>
          </i-button>
        </p>
      </div>
    </app-layout>
  </div>
</template>

<script>
export default {
  watch: {
    "$route": function(n,o) {
      if(n)
        this.email = this.$route.query.hasOwnProperty("email") ? this.$route.query.email : null;
    }
  },
  mounted() {
    this.email = this.$route.query.hasOwnProperty("email") ? this.$route.query.email : null;
    if ( !this.email ) this.$router.replace("/home");
  },
  data() {
    return {
      email: null
    }
  },
  methods:{
    resendVerification() {
      this.$store.dispatch("user/verification", {email: this.email})
        .then( res => {
          this.$Modal.success({
            title: "Success",
            content: "Confirmation mail sent!."
          });
        })
    }
  },
  computed: {
    myEmail() {
      return this.email;
    }
  }
}
</script>

<style>

</style>
